export const SITE = {
  name: "MG Tiling Pro",
  tagline: "Professional tiling across Dublin and surroundings.",
  phone: "083 209 1787",
  phoneRaw: "+353832091787",
  email: "mihaigurzujr@gmail.com",
  location: "Dublin & Surroundings",
  areas: ["Dublin City", "North Dublin", "South Dublin", "Fingal", "Wicklow", "Kildare", "Meath"],
};

export const IMAGES = {
  heroTexture: "/media/hero-bathroom.png",
  craftsman:
    "https://images.unsplash.com/photo-1523413363574-c30aa1c2a516?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjcmFmdHNtYW4lMjBsYXlpbmclMjB0aWxlcyUyMGhhbmRzfGVufDB8fHx8MTc4MzIwNTU3MHww&ixlib=rb-4.1.0&q=85",
  bathroom:
    "https://images.unsplash.com/photo-1701251786408-d0320ecaad8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYXRocm9vbSUyMG1hcmJsZSUyMHRpbGluZyUyMGludGVyaW9yfGVufDB8fHx8MTc4NTQ5ODI0N3ww&ixlib=rb-4.1.0&q=85",
  bathroomAlt:
    "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbSUyMG1hcmJsZSUyMHRpbGluZyUyMGludGVyaW9yfGVufDB8fHx8MTc4NTQ5ODI0N3ww&ixlib=rb-4.1.0&q=85",
  kitchen: "https://images.pexels.com/photos/10855206/pexels-photo-10855206.jpeg",
  outdoor: "https://images.unsplash.com/photo-1603518147332-ba54b96276a3",
  geometric:
    "https://images.unsplash.com/photo-1551893478-d726eaf0442c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxnZW9tZXRyaWMlMjBmbG9vciUyMHRpbGVzJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODI2MTYyMDd8MA&ixlib=rb-4.1.0&q=85",
};

export const VIDEOS = [
  {
    id: "01",
    tag: "On-Site",
    title: "Set-Out & Cuts",
    src: "/media/v1.mp4",
    poster: "/media/v1.jpg",
    span: "md:col-span-8",
    ratio: "aspect-video",
  },
  {
    id: "02",
    tag: "Bathroom Tiling",
    title: "Full Bathroom Install",
    src: "/media/v4.mp4",
    poster: "/media/v4.jpg",
    span: "md:col-span-4",
    ratio: "aspect-[3/4]",
  },
  {
    id: "03",
    tag: "Wall Tiling",
    title: "Large-Format Walls",
    src: "/media/v2.mp4",
    poster: "/media/v2.jpg",
    span: "md:col-span-4",
    ratio: "aspect-video",
  },
  {
    id: "04",
    tag: "Floor Tiling",
    title: "Precision Floor Lay",
    src: "/media/v3.mp4",
    poster: "/media/v3.jpg",
    span: "md:col-span-4",
    ratio: "aspect-video",
  },
  {
    id: "05",
    tag: "Finished Project",
    title: "The Final Finish",
    src: "/media/v5.mp4",
    poster: "/media/v5.jpg",
    span: "md:col-span-4",
    ratio: "aspect-video",
  },
];

export const SERVICES = [
  {
    no: "01",
    title: "Bathroom Tiling",
    desc: "Full wet-wall systems, feature niches and large-format porcelain, sealed to last a lifetime.",
    img: IMAGES.bathroomAlt,
  },
  {
    no: "02",
    title: "Kitchen & Splashback",
    desc: "Precision splashbacks, honed worktops and floor transitions cut to the millimetre.",
    img: IMAGES.kitchen,
  },
  {
    no: "03",
    title: "Floor & Wall Tiling",
    desc: "Level-five substrates and laser-set patterns for floors that read perfectly flat.",
    img: IMAGES.geometric,
  },
  {
    no: "04",
    title: "Wet Rooms",
    desc: "Tanked, graded and drained wet rooms engineered for zero-threshold living.",
    img: IMAGES.bathroom,
  },
  {
    no: "05",
    title: "Outdoor & Patios",
    desc: "Frost-proof porcelain paving and terraces that carry the interior line outside.",
    img: IMAGES.outdoor,
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Precision",
    body: "Every cut is measured twice and set once. We work to a 1mm tolerance because a floor is only as good as its worst joint.",
  },
  {
    no: "02",
    title: "Material",
    body: "Marble, porcelain, terrazzo, natural stone. We understand how each material moves, breathes and ages in the Irish climate.",
  },
  {
    no: "03",
    title: "Substrate",
    body: "The tile is the finish, not the fix. We build correct, waterproofed, decoupled substrates that outlive the fashion above them.",
  },
  {
    no: "04",
    title: "Finish",
    body: "Grout lines that run true, silicone that reads invisible, edges mitred by hand. The details you only notice when they are wrong.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "MG Tiling Pro retiled our entire ground floor and the level of the finish is genuinely something else. Not a single lippage anywhere.",
    name: "Aoife M.",
    place: "Ranelagh, Dublin 6",
  },
  {
    quote:
      "Mihai tanked and tiled a wet room for my mother. Clean, on time, and the mitred edges are flawless. Worth every euro.",
    name: "Cathal O.",
    place: "Greystones, Wicklow",
  },
  {
    quote:
      "Large-format porcelain across a whole kitchen is not easy. He made it look effortless. Highly recommend MG Tiling Pro.",
    name: "Niamh D.",
    place: "Malahide, Co. Dublin",
  },
];
